import { Global, css } from "@emotion/react";
import emotionNormalize from "emotion-normalize";
import styled from "@emotion/styled";

import { pxToRem } from "@src/utils";
import { LdInputMessage } from "@emdgroup-liquid/liquid/dist/react";

export const HEADER_HEIGHT = 75;

export const baseFontSize = 16;

export const zIndex = {
  header: 2,
  footer: 1,
  logosBar: 1,
  baseLayoutMain: 1,
} as const;

export const GlobalStyles = () => (
  <Global
    styles={css`
      ${emotionNormalize}
      * {
        box-sizing: border-box;
        scroll-margin-top: ${pxToRem(HEADER_HEIGHT * 2)};
      }

      html,
      body {
        padding: 0;
        margin: 0;
        font-size: ${(baseFontSize / 16) * 100 + "%"};
        font-family: "Lato", sans-serif;
      }

      html {
        height: 100%;
      }

      body {
        min-height: 100%;
        --horizontal-paddings: ${pxToRem(10)}; // 100 if padding required
        --col-underline-gray: #a4a19b;
      }

      ld-select-popper {
        ::part(popper-scroll-container) {
          --ld-select-popper-max-height: ${pxToRem(200)};
        }
      }

      body,
      #root,
      #root > div {
        display: flex;
        flex-direction: column;
        flex: 1;
      }

      .ld-progress {
        width: 100%;
      }
    `}
  />
);

export const StyledRow: any = styled.div`
  display: flex;
  flex-direction: ${({ direction }: any) => direction || "row"};
  justify-content: ${({ justify }: any) => justify || "space-evenly"};
  align-items: ${({ alignItems }: any) => alignItems || "center"};
  width: 100%;
  gap: ${({ gap }: any) => pxToRem(gap)};
  margin: 8px;
`;

export const StyledColumn: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: ${({ width }: any) => width}%;
`;

export const StyledMessage: any = styled.div`
  width: ${({ width }: any) => width}%;
  color: ${({ color }: any) => color};
`;

export const StyledLDMessage : any = styled(LdInputMessage)`
   font-weight: bold;
`